export default __webpack_public_path__ + "static/media/btn_team.bf29107d.png";